import { render, staticRenderFns } from "./ModuleMessageVerify.vue?vue&type=template&id=3f24d5d0&scoped=true"
import script from "./ModuleMessageVerify.vue?vue&type=script&lang=js"
export * from "./ModuleMessageVerify.vue?vue&type=script&lang=js"
import style0 from "./ModuleMessageVerify.vue?vue&type=style&index=0&id=3f24d5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24d5d0",
  null
  
)

export default component.exports